import { render } from "./CircledPauseIcon.vue?vue&type=template&id=6dd30981&scoped=true"
import script from "./CircledPauseIcon.vue?vue&type=script&lang=js"
export * from "./CircledPauseIcon.vue?vue&type=script&lang=js"

import "./CircledPauseIcon.vue?vue&type=style&index=0&id=6dd30981&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dd30981"

export default script